import React, { Component } from 'react';
import Header from '../../Shared/Header';
import Footer from '../../Shared/Footer';
import Button from '../../Shared/Button';
import Footer2 from '../../Shared/Footer2';
import UploadFile from '../../Shared/UploadMultipleFile';
import '../../../css/YourOrders/ShipmentDetails.css';
import MetaDecorator from '../../../ReactHelmet/MetaDecorator';
import TitleDescription from '../../../Data/Shared/TitleDescription.json';
import container from '../../../Assets/ContainerStatus/Assets_Desktop/container.svg';
import deliveryTime from '../../../Assets/NominateRequest/deliveryTime.svg';
import pickupTime from '../../../Assets/NominateRequest/pickupTime.svg';
import offloadTime from '../../../Assets/NominateRequest/offloadTime.svg';

class ShipmentDetails extends Component {
    constructor(props) {
        super(props)
        this.container = React.createRef();
        this.state = {
            ContainerNo: 'MRSU3562332',
            containerData: [
                { key: "Haulage Company", value: "ABC Transport Limited" },
                { key: "Truck", value: "ND613690" },
                { key: "Destination", value: "City Centre" },
                { key: "Delivery Code", value: "ZA CTT" },
                { key: "Bonded Destination", value: "XXXX" },
                { key: "Delivery Priority", value: "Collection during vessel discharge (?)" },
            ],
            containerLocationData: [
                { key: "Pickup Location", value: "Durban Pier Two Container Terminal" },
                { key: "Tower", value: "XXXX" },
                { key: "Block Collection", value: "XXXX" },
                { key: "Gate Out", value: "XXXX" },
            ],
            containerDetailsData: [
                { key: "Shipper", value: "XYZ Clearing Services" },
                { key: "Consignee", value: "John Smith" },
                { key: "Vessel Name", value: "COSCO SURABAYA" },
                { key: "Visit ID", value: "DCT7232" },
                { key: "Bill Of Lading (BOL)", value: "ONEYNB0BCN702600" },
            ],
            filePathCIPC: '',
            uploadedFilesData: [],
            StartTrip: true,
            EndTrip: true,
            CompleteOffload: true,
            PickupTime: '29-Oct-2020 16:30',
            DeliveryTime: '29-Oct-2020 17:04',
            OffloadTime: '29-Oct-2020 17:45',
        }
        this.handleClickOutside = this.handleClickOutside.bind(this);
    }
    componentDidMount = () => {
        document.addEventListener("mousedown", this.handleClickOutside);
    }
    handleClickOutside = event => {
        if (this.container.current && !this.container.current.contains(event.target)) {
            this.setState({ RoleTypedropdown: false });
            this.setState({ PreferredCompanydropdown: false });
        }
    };
    handleStartTrip = () => {
        if (!this.state.EndTrip) {
            this.setState({ CompleteOffload: false });
        }
        if (!this.state.StartTrip) {
            this.setState({ EndTrip: false });
        }
        this.setState({ StartTrip: false })
    }
    callbackUploadedFilesFunction = (FilesData) => {
        this.setState({ uploadedFilesData: FilesData });
        console.log("callbackUploadedFilesFunction", this.state.uploadedFilesData);
    }
    uploadFileFun = (uploadConfirm) => {
    }
    setUploadLinkCIPC = (filePathURL) => {
        this.setState({ filePathCIPC: filePathURL })
        console.log("CIPC", filePathURL);
    }
    setLoaderCIPC = (filePathURL) => {
    }
    render() {
        if (this.state.searchPreferredCompanylength > 0) {
            this.state.PreferredCompanydataFound = this.state.PreferredCompanydata.filter(i => i.name.toLowerCase().startsWith(this.state.PreferredCompany.toLowerCase()))
        } else {
            this.state.PreferredCompanydataFound = [];
        }
        return (
            <div class="ShipmentDetailsOutercolor">
                <MetaDecorator title={TitleDescription.contactUsPageTitle} description={TitleDescription.contactUsPageDescription} />
                <Header tilesFetched={() => { }} />
                <div class="ShipmentDetailsOuterDivcss">
                    <div id="ShipmentDetailsBoxDiv">
                        <nav class="ShipmentDetailsNavbar">
                            <div className="ShipmentDetailsNavbarName">
                                <small id="ShipmentDetailsNavbarText">Shipment Details</small>
                            </div>
                        </nav>
                        <hr class="hr1" />
                        <div class="ShipmentDetailsMidPartition">
                            <div class="ShipmentDetailsMainInsideDiv">
                                <div class="ShipmentDetailsInnerHead">
                                    <img src={container} />
                                    <div class="ShipmentDetailsHeadText">Container No.</div>
                                    <div class="ShipmentDetailsContainernoText">{this.state.ContainerNo}</div>
                                </div>
                                {!this.state.EndTrip &&
                                    <div class="ShipmentDetailsDataDiv">
                                        <div class="ShipmentDetailsDataInDiv">
                                            <div class="ShipmentDetailsDataleftTime">
                                                <img id="ShipmentDetailsleftTimeimg" src={pickupTime} />
                                                <text class="ShipmentDetailsleftTimeText">Pickup Time</text>
                                            </div>
                                            <div class="ShipmentDetailsDataright">
                                                <text class="ShipmentDetailsrightTimeText">{this.state.PickupTime}</text>
                                            </div>
                                        </div>
                                        <div class="ShipmentDetailsDataInDiv">
                                            <div class="ShipmentDetailsDataleftTime">
                                                <img id="ShipmentDetailsleftTimeimg" src={deliveryTime} />
                                                <text class="ShipmentDetailsleftTimeText">Delivery Time</text>
                                            </div>
                                            <div class="ShipmentDetailsDataright">
                                                <text class="ShipmentDetailsrightTimeText">{this.state.DeliveryTime}</text>
                                            </div>
                                        </div>
                                        {!this.state.CompleteOffload &&
                                            <div class="ShipmentDetailsDataInDiv">
                                                <div class="ShipmentDetailsDataleftTime">
                                                    <img id="ShipmentDetailsleftTimeimg" src={offloadTime} />
                                                    <text class="ShipmentDetailsleftTimeText">Offload Time</text>
                                                </div>
                                                <div class="ShipmentDetailsDataright">
                                                    <text class="ShipmentDetailsrightTimeText">{this.state.OffloadTime}</text>
                                                </div>
                                            </div>
                                        }
                                    </div>
                                }
                                <div class="ShipmentDetailsDataDiv">
                                    {(this.state.containerData?.map((val, key) => {
                                        return (
                                            <div class="ShipmentDetailsDataInDiv">
                                                <div class="ShipmentDetailsDataleft">
                                                    <text class="ShipmentDetailsleftText">{val.key}</text>
                                                </div>
                                                <div class="ShipmentDetailsDataright">
                                                    <text class="ShipmentDetailsrightText">{val.value}</text>
                                                </div>
                                            </div>
                                        );
                                    }))}
                                </div>
                                <div class="ShipmentDetailsDataDiv">
                                    {(this.state.containerLocationData?.map((val, key) => {
                                        return (
                                            <div class="ShipmentDetailsDataInDiv">
                                                <div class="ShipmentDetailsDataleft">
                                                    <text class="ShipmentDetailsleftText">{val.key}</text>
                                                </div>
                                                <div class="ShipmentDetailsDataright">
                                                    <text class="ShipmentDetailsrightText">{val.value}</text>
                                                </div>
                                            </div>
                                        );
                                    }))}
                                </div>
                                <div class="ShipmentDetailsDataDiv">
                                    {(this.state.containerDetailsData?.map((val, key) => {
                                        return (
                                            <div class="ShipmentDetailsDataInDiv">
                                                <div class="ShipmentDetailsDataleft">
                                                    <text class="ShipmentDetailsleftText">{val.key}</text>
                                                </div>
                                                <div class="ShipmentDetailsDataright">
                                                    <text class="ShipmentDetailsrightText">{val.value}</text>
                                                </div>
                                            </div>
                                        );
                                    }))}
                                </div>
                                {this.state.StartTrip ?
                                    <div class="ShipmentDetailsUploadDiv">
                                        <small class="ShipmentDetailsUploadText">Upload Container Images (Optional)</small>
                                        <div>
                                            <UploadFile uploaddivid="uploadCIPC" idupload="upload"
                                                name="fileupload"
                                                fileType="jpeg, jpg, png, pdf"
                                                setUploadConfirm={this.uploadFileFun}
                                                upload_link="cipcUpload" uploadicon="cipcIcon"
                                                setFileLink={this.setUploadLinkCIPC}
                                                setLoader={this.setLoaderCIPC}
                                                ShipmentDetailesCallback={this.callbackUploadedFilesFunction}
                                            />
                                        </div>
                                        <small class="ShipmentDetailsUploadBottomText">You can upload maximum 3 images</small>
                                    </div>
                                    :
                                    <div class="ShipmentDetailsUploadDiv">
                                        <small class="ShipmentDetailsUploadText">Container Images</small>
                                        {(this.state.uploadedFilesData.length > 0) ?
                                            <div class="ShipmentDetailsUploadedFiles">
                                                {this.state.uploadedFilesData.map((val, index) => {
                                                    return (
                                                        <>
                                                            <span className="ShipmentuploadedFileSpan">
                                                                <div className="ShipmentuploadedFilename">
                                                                    <div className="ShipmentuploadedFiletext">{val}</div>
                                                                </div>
                                                            </span>
                                                            <hr className="predocspanhr" style={{ display: "flex" }} />
                                                        </>)
                                                })}
                                            </div>
                                            :
                                            <div class="ShipmentDetailsEmpthyFies">
                                                <text class="ShipmentDetailsEmpthyFiestext">No image Uploaded</text>
                                            </div>
                                        }
                                    </div>
                                }
                                {this.state.CompleteOffload &&
                                    <div class="ShipmentDetailsBtnDiv">
                                        <Button class="ShipmentDetailsBtn" onClick={this.handleStartTrip}>
                                            {this.state.StartTrip ?
                                                <small class="caabuttdiv2">Start Trip</small>
                                                :
                                                (this.state.EndTrip ?
                                                    <small class="caabuttdiv2">End Trip</small>
                                                    :
                                                    <small class="caabuttdiv2">Complete Offload</small>
                                                )
                                            }
                                        </Button>
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                </div>
                <div class="ShipmentDetailsFooterUnfixed">
                    <Footer />
                </div>
                <div class="ShipmentDetailsFooterFixed">
                    <Footer2 />
                </div>
            </div >
        );
    }
}
export default ShipmentDetails;